module.exports = {
  form: {
    resetBtn: "重置",
    confirmBtn: "确定",
    cancelBtn: "取消",
    formTitle: "编辑",
    formValidateErr: "请按提示检查输入项",
    pleaseInput: "请输入",
    submitSuccess: "提交成功！",
    submitErr: "提交失敗！原因：",
  },
  search: {
    selete: "請選擇",
    input: "請輸入",
    doSearch: "搜索",
  },

  adminBase: {
    addBtn: "新增",
    searchBtn: "搜索",
    edit: "编辑",
    delete: "删除",
  },

  table: {
    view: "詳情",
    operation: "Action",
    confirm: "確認選擇",
    selected: "已選：",
    sort: "排序",
    save: "保存",
  },
  uploader: {
    text: "Choose file to upload",
  },
};
